import FeaturedContent from "@/components/blocks/FeaturedContentBlock";
import LoadingSpinner from "@/components/LoadingSpinner";
import PageHeading from "@/components/PageHeading";
import PageNumbers from "@/components/PageNumbers";
import { pushQueryParam, removeRootPage } from "@/lib/utils";
import {
	ProjectListingPage as ProjectListingPageType,
	ProjectPagePaginatedType,
	useGetProjectListingQuery,
} from "graphql/generated-types";
import { useRouter } from "next/router";
import React from "react";
import { IndexContainer } from "./IndexContainer";

const ProjectListingPage = ({ data }: { data: ProjectListingPageType }) => {
	const router = useRouter();
	const perPage = 4;
	const { data: queryResults, loading } = useGetProjectListingQuery({
		variables: {
			page: router.query.page ? parseInt(router.query.page as string) : 1,
			perPage: perPage,
		},
	});
	const projectPages = queryResults?.projectPages as ProjectPagePaginatedType;
	const total = projectPages?.pagination?.total;
	const pages = Math.ceil(total / perPage);
	const currentPage = router.query.page ? parseInt(router.query.page as string) : 1;

	const handlePageChange = (page: number) => {
		pushQueryParam(`?page=${page}`, router);
	};

	const handleNextPage = () => {
		const nextPage = router.query.page ? parseInt(router.query.page as string) + 1 : 2;
		handlePageChange(nextPage);
	};

	return (
		<IndexContainer>
			<PageHeading title={data.title} />
			{loading && (
				<div className="flex justify-center mt-16">
					<LoadingSpinner />
				</div>
			)}
			<div className="grid gap-24 lg:gap-48 mt-36">
				{projectPages?.items
					?.filter((p) => p !== null)
					.map((projectPage, i) => {
						return (
							<FeaturedContent
								key={i}
								title={projectPage?.title!}
								content={projectPage?.description!}
								image={projectPage?.heroImage}
								link={removeRootPage(projectPage?.urlPath!)}
								linkText="View project"
							/>
						);
					})}
			</div>
			<PageNumbers
				currentPage={currentPage}
				pages={pages}
				handlePageChange={handlePageChange}
				handleNextPage={handleNextPage}
			/>
		</IndexContainer>
	);
};

export default ProjectListingPage;
